/* Hidden on screen — only rendered for printing. */
.exportRoot {
  display: none;
}

.head {
  margin-bottom: 18px;
  border-bottom: 2px solid #000;
  padding-bottom: 8px;
}
.title {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: 26px;
}
.date {
  margin: 2px 0 0;
  font-size: 15px;
  color: #333;
}
.section {
  margin: 0 0 14px;
  break-inside: avoid;
}
.h2 {
  margin: 0 0 4px;
  font-family: var(--token-font-display);
  font-size: 16px;
}
.body {
  margin: 0;
  font-size: 14px;
  white-space: pre-line;
}
.answer {
  margin: 4px 0 0;
  font-size: 14px;
  font-style: italic;
}
.list {
  margin: 4px 0 0;
  padding-left: 20px;
  font-size: 14px;
}
.list li {
  margin: 2px 0;
}
.muted {
  color: #666;
}

@media print {
  /* Reveal only the export root; hide the rest of the app. */
  :global(body) * {
    visibility: hidden !important;
  }
  .exportRoot,
  .exportRoot * {
    visibility: visible !important;
  }
  .exportRoot {
    display: block;
    position: absolute;
    inset: 0;
    margin: 0;
    padding: 24px 28px;
    background: #fff;
    color: #000;
    font-family: var(--token-font-body);
  }
}
